import "@mpa/toolbox/parsing/superstruct";
import "reshaped/themes/slate/theme.css";

import { css, Global } from "@emotion/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Reshaped } from "reshaped";

import { App } from "./App.tsx";
import Await from "./components/async/Await.tsx";
import Page from "./components/Page/index.tsx";
import { queryClient } from "./data/tanstack-query.ts";
import { SafeAreaProvider } from "./layouts/SafeArea/index.tsx";
import { enableInternalNavigationDetector } from "./navigation/location.ts";
import { setRouteViewWrapper } from "./navigation/RouteViewConfig.ts";

enableInternalNavigationDetector();
setRouteViewWrapper(Page);

const root = document.getElementById("root");

if (!root) {
    throw new Error("Root element #root introuvable");
}

const globalStyles = css({
    html: { height: "100%", margin: 0 },
    body: { height: "100%", margin: 0 },
    "#root": { height: "100%", margin: 0 },
    "[data-rs-theme~='slate']": {
        "--rs-font-family-body": "Outfit, sans-serif",
        "--rs-font-family-title": "Outfit, sans-serif",
        "--rs-font-family-headline": "Outfit, serif",
        "--rs-font-family-monospace": "ui-monospace, monospace",
    },
    a: {
        textDecoration: "none",
        color: "inherit",
        cursor: "pointer",
    },
});

createRoot(root).render(
    <StrictMode>
        <Reshaped theme="slate">
            <QueryClientProvider client={queryClient}>
                <Await>
                    <Global styles={globalStyles} />
                    <SafeAreaProvider>
                        <App />
                    </SafeAreaProvider>
                </Await>
            </QueryClientProvider>
        </Reshaped>
    </StrictMode>,
);
